import React from 'react';
import BaseModalComponent from './BaseModal';
import Editor from 'react-tinymce';
import Select from 'react-select';
import Uploader from 'react-images-upload';
import DatePicker from 'react-datepicker2';
//to use history.push
import { withRouter } from 'react-router-dom';
import {  Link } from 'react-router-dom';

class LegalPerson extends BaseModalComponent {
  constructor(props) {
    super(props, "edit", 1, null);
    this.state.ImageContent = '';
    this.state.subModuleName = "edit";

    this.state.cites = [];

    this.onDropCover = this.onDropCover.bind(this);
    this.onDropLogo = this.onDropLogo.bind(this);
    this.cityRef = React.createRef();

    this.state.startDate = null;
    this.state.finishDate = null;
    this.state.deadline2 = null;
    this.state.deadline = null;    

    this.state.PaperRecievType = '1';
    this.state.PaperRecievTypeDone = false;

    this.state.openedChilds = 0;
    this.state.key = "person_id";

    this.state.link_cell_validator_message = null;
    
    this.state.id_to_edit = props.legalPersonId;
    this.state.extractIssueResualt = null;
    this.state.showLog = false;

    this.state.subModuleName = props.subModuleName;
  }
  loadRealPersonsOptions(inputValue, callback) {
    setTimeout(() => {
      fetch("/api/organ/ajax/realpersons/", {
        method: "post",
        body: JSON.stringify({ "term": inputValue }),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => response.json())
        .then(records => {
          let items = [];
          records.map(_record => items.push(this.getRealPersonAutocompleteTemplate(_record)));
          callback(items);
        })

    }, 50);
  }
  getAccessToRoles() {
    return this.state.subModuleName === 'legalpersons' ? true : false
  }
  onDropMedia(picture, id) {
    if (picture.length <= 0) {
      return;
    }
    let reader = new FileReader();
    let file = picture[0];

    reader.onloadend = () => {
      this.setMediaValue(reader.result, "filename", id);
    }
    reader.readAsDataURL(file)
  }
  componentWillReceiveProps(props) {
    this.state.cites = [];
    this.setInitialProps(props);
  }
  setInitialProps(props) {
    this.state.id_to_edit = props.legalPersonId;
    this.state.extractIssueResualt = null;
    this.state.showLog = false;

    this.state.subModuleName = props.subModuleName;

    if (this.state.id_to_edit === null)
      this.openNewForm();
    else
      this.openModifyForm();//this.state.id_to_edit
  }
  saveForm(op='') {
    this.setState({messages: []});
    this.lockScreen();
    let type = "add";
    if (this.state.id_to_edit == 0)
      type = "add";
    else
      type = "edit";

    var get_url = '/api/organ/edit/';
    fetch(get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": type,
        "form": this.state.form_data.record,
        //این بخش در بعضی جاها نیاز هست
        "medias":this.state.form_data.medias
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((resualt) => {
      this.unLockScreen();
      if (resualt.status == 1) {
        this.showToast('اطلاعات با موفقیت ذخیره شد.','success');

        if (!this.isBlank(resualt.url)){
          this.go(resualt.url);
          return;
        }
        //ادرس مسیر جاری رو بدست میاره و اسم دامین و پروتکل رو از ادرس حذف میکنه
        var u = window.location.href.toString().replace(window.location.origin+'/organ/','/');

        if (u.substr(-1)!='/') u = u + "/";
        
        //چون ابتدا و انتها اسلش داریم داریم برای همین بایستی توجه بشه که اندیس اول و اخر ارایه خالی خواهد بو
        u = u.toLocaleLowerCase();
        let urlSections = u.split("/");
        // module/action/id

        // in specialpersons
        // module/legalid/action/id

        if (op === '') {
          if (urlSections[2] === "edit")
          {
            window.location.reload();
            return;
          }
          if (urlSections[2] === "new")
            this.go('/' + urlSections[1] + "/edit/" + resualt.id + "/");
        }
        else{
          if (op === 'return')
            this.go('/' + urlSections[1] + "/");
          else
            window.location.href = window.location.origin + op + resualt.id ;
        }
      }
      else
      {
        if (resualt.message === undefined && resualt.messages == undefined)
        this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
        else{
          if (resualt.messages != undefined){
            this.setState({messages: resualt.messages});
            this.showToast("لطفا خطاهای نمایش داده شده را برطرف نمایید",'warning');
            if (typeof window !== "undefined")
                window.scrollTo(0, 0);
          }
          else{
            this.showToast(resualt.message,'warning');
          }
        }
      }
    })
    .catch(err=>{
      this.unLockScreen();
      this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.','danger');
    });
  }
  openNewForm() {
    this.lockScreen();
    this.setState({ id_to_edit: 0 });
    var get_url = '/api/organ/edit/';
    fetch(get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": "new",
        "extra_fields":this.state.extra_fields
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(form_data => {
      this.setState({ form_data });
      this.unLockScreen();
    }
    ).catch(err=>{
      this.showToast("خطایی در نمایش اطلاعات پیش آمده است.","danger");
      this.unLockScreen();
    });
  }
  openModifyForm() {
    this.lockScreen();
    //this.setState({ id_to_edit: id });
    var get_url = '/api/organ/edit/';
    fetch(get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": "get",
        "id": this.state.id_to_edit,
        "subModuleName": this.state.subModuleName,
        "extra_fields":this.state.extra_fields
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(form_data => {
      this.setState({ form_data });
      this.unLockScreen();
    }).catch(err=>{
        this.showToast('خطایی در نمایش اطلاعات رخ داده است.','danger');
        this.unLockScreen();
    });
  }
  onDropCover(picture) {
    if (picture.length === 0) {
      return;
    }
    let reader = new FileReader();
    let file = picture[0];

    reader.onloadend = () => {
      this.state.form_data.record.cover = reader.result;
      this.setState({ImageContent:reader.result});
    }
    reader.readAsDataURL(file)
  }
  onDropLogo(picture) {
    if (picture.length === 0) {
      return;
    }
    let reader = new FileReader();
    let file = picture[0];
    reader.onloadend = () => {
      this.state.form_data.record.logo = reader.result;
    }
    reader.readAsDataURL(file)
  }
  //مقادیر وارد شده در فرم اطلاعات تماس رو درون لیست مورد نظر آپدیت میکنیم
  setContactFormValues(field, e, ContactId) {
    let form_data = this.state.form_data;
    for (let i = 0; i < form_data.record.Contacts.length; i++)
      if (form_data.record.Contacts[i].id === ContactId)
        form_data.record.Contacts[i][field] = e.target.value;
    this.setState({ form_data });
  }
  //ردیف مورد نظر در لیست اطلاعات تماس رو حذف میکنیم
  removeContacts(e, id) {
    let form_data = this.state.form_data;
    let temp = [];
    for (var i = 0; i < form_data.record.Contacts.length; i++)
      if (form_data.record.Contacts[i].id !== id)
        temp.push(form_data.record.Contacts[i]);
    form_data.record.Contacts = temp;
    this.setState({ form_data });
  }
  //یه آیتم خالی جدید به لیست تماس ها اضافه میکنیم.جهت افزودن آیتم جدید به فرم
  addContacts(e, contact_type = 1) {
    let form_data = this.state.form_data;
    form_data.record.Contacts.push({ id: this.uuidv4(), value: '', contact_type: contact_type });
    this.setState({ form_data });
  }
  //تنظیم مقادیر فیلدهای اختصاصی
  setPersonField(e, field, isEditor = false, isDatePicker = false) {
    var v = '';
    if (e === null) {
      v = null
    }
    else {
      if (isEditor)
        v = e.target.getContent();
      else {
        if (isDatePicker)
          v = e;
        else {
          if (e.target.type === 'checkbox')
            v = e.target.checked ? "1" : "0";
          else
            v = e.target.value;
        }
      }
    }
    var exist = false;

    for (let i = 0; i < this.state.form_data.record.Fields.length; i++)
      if (this.state.form_data.record.Fields[i].field === field) {
        exist = true;
        this.state.form_data.record.Fields[i].value = v;
      }
    if (exist === false) {
      this.state.form_data.record.Fields.push({ id: this.uuidv4(), field: field, value: v });
    }
  }
  addChildPerson() {
    let ex = false;
    for (var i = 0; i < this.state.form_data.child_persons.length; i++)
      if (this.state.form_data.child_persons[i].person_id.toString().includes("-"))
        ex = true;

    if (ex) return;

    let newPerson = {
      person_id: this.uuidv4(),
      issue: '',
      volume: '',
      name: '',
      link_cell: '',
      parent_id: this.state.form_data.record.person_id
    };
    this.state.form_data.child_persons.push(newPerson);
    this.setState({ openedChilds: newPerson.person_id });
  }
  setChildPersonsValues(e, f, person_id) {
    for (var i = 0; i < this.state.form_data.child_persons.length; i++)
      if (this.state.form_data.child_persons[i].person_id === person_id)
        this.state.form_data.child_persons[i][f] = e.target.value;
  }
  saveChild(person_id) {
    let person = null;
    for (var i = 0; i < this.state.form_data.child_persons.length; i++)
      if (this.state.form_data.child_persons[i].person_id === person_id)
        person = this.state.form_data.child_persons[i];

    if (person.name === "") {
      this.showToast("لطفا عنوان این شماره را وارد نمایید", "warning");
      return;
    }
    if (person.link_cell === "") {
      this.showToast("لطفا کد اختصاصی این شماره را وارد نمایید", "warning");
      return;
    }
    if (person.issue === "") {
      this.showToast("شماره وارد شده معتبر نمی باشد.", "warning");
      return;
    }
    if (person.volume === "") {
      this.showToast("عدد دوره وارد شده معتبر نمی باشد.", "warning");
      return;
    }

    this.lockScreen();
    fetch("/api/organ/ajax/issueupdate/", {
      method: 'POST',
      body: JSON.stringify({
        "person": person
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 1) {
        //اگه رکور جدید باشه بایستی ای دی رو با ایدی موقت جابجا کنیم
        if (data.person_id !== undefined) {
          for (var i = 0; i < this.state.form_data.child_persons.length; i++)
            if (this.state.form_data.child_persons[i].person_id === person_id)
              this.state.form_data.child_persons[i].person_id = data.person_id;

          this.showToast("اطلاعات شماره ژورنال با موفقیت ثبت گردید", "success");
        }
        else
          this.showToast("اطلاعات شماره ژورنال با موفقیت بروز گردید", "success");
        this.setState({ openedChilds: 0 });
      }
      else
        this.showToast(data.message, "danger");
      this.unLockScreen()
    })
    .catch(err => { this.showToast("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.", "danger"); this.unLockScreen() });
  }
  OpenWebsite() {
    if (this.state.form_data.record.website === '') return;
    window.open(this.state.form_data.record.website);
  }
  getCaption(){
    if (this.state.subModuleName === 'conf') return 'کنفرانس';
    if (this.state.subModuleName === 'uni') return 'مرکز';
    if (this.state.subModuleName === 'journal') return 'مجله';
    if (this.state.subModuleName === 'issue') return 'شماره';
    if (this.state.subModuleName === 'issue_temp') return 'شماره';
    return "مرکز"
  }
  //رندر کردن فیلدهای مورد نیاز برای نقش کنفرانس
  getConfrenceForm() {
    return (
      <div className="box box-info">
        <div className="box-header with-border">
          <h3 className="box-title">زمانبندی برگزاری کنفرانس</h3>
        </div>
        <div className="form-horizontal">
          <div className="box-body">
            <div className="form-group">
              <label className="col-sm-12 control-label">تاریخ شروع <a onClick={() => this.startDate_dt_ref3.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.startDate_dt_ref3 = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"تاریخ شروع"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => {
                    if (e == this.state.start) return;
                    this.setState({ startDate: this.getFormatedDateForDatePicker(e, true) });
                    this.setDateValue(e, 'start');
                  }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.start)}
                />

              </div>
              <label className="col-sm-12 control-label">تاریخ اتمام <a onClick={() => this.finishDate_dt_ref3.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.finishDate_dt_ref3 = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"تاریخ اتمام"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => {                    
                    if (e == this.state.finishDate) return;
                    this.setState({ finishDate: this.getFormatedDateForDatePicker(e, true) });
                    this.setDateValue(e, 'finish');
                  }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.finish)}
                />
              </div>
              <label className="col-sm-12 control-label">مهلت ثبت نام <a onClick={() => this.register_deadline_dt_ref.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.register_deadline_dt_ref = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"مهلت ثبت نام"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => { this.setDateValue(e, 'register_deadline') }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.register_deadline)}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-12 control-label">مهلت چکیده <a onClick={() => this.deadline2_dt_ref.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.deadline2_dt_ref = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"مهلت چکیده"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => {
                    if (e == this.state.deadline2) return;
                    this.setState({ deadline2: this.getFormatedDateForDatePicker(e, true) });
                    this.setDateValue(e, 'deadline2');
                  }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.deadline2)}
                />
              </div>
              <label className="col-sm-12 control-label">اعلام چکیده <a onClick={() => this.resualt_date2_dt_ref.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.resualt_date2_dt_ref = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"اعلام چکیده"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => { this.setDateValue(e, 'resualt_date2') }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.resualt_date2)}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-12 control-label">ارسال اصل مقالات <a onClick={() => this.deadline_dt_ref.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.deadline_dt_ref = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"ارسال اصل مقالات"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => {
                    if (e == this.state.deadline) return;
                    this.setState({ deadline: this.getFormatedDateForDatePicker(e, true) });
                    this.setDateValue(e, 'deadline');
                  }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.deadline)}
                />
              </div>
              <label className="col-sm-12 control-label">اعلام داوری مقالات <a onClick={() => this.resualt_date_dt_ref.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.resualt_date_dt_ref = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"اعلام داوری مقالات"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => { this.setDateValue(e, 'resualt_date') }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.resualt_date)}
                />
              </div>
              <label className="col-sm-12 control-label">آخرین مهلت ارسال مقالات <a onClick={() => this.final_deadline_dt_ref.removeDate()} title="خالی کردن تاریخ"><i className="fa fa-eraser"></i></a></label>
              <div className="col-sm-12">
                <DatePicker
                  ref={r => {
                    this.final_deadline_dt_ref = r;
                  }}
                  inputReadOnly={true}
                  className="form-control"
                  placeholder={"آخرین مهلت ارسال مقالات"}
                  isGregorian={false}
                  showTodayButton={true}
                  timePicker={false}
                  onChange={(e) => { this.setDateValue(e, 'final_deadline') }}
                  value={this.getFormatedDateForDatePicker(this.state.form_data.record.final_deadline)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  renderBody() {
    return [
      <div className="row">
        {this.state.form_data.record.role_id == 7 && <a href={"/l/" + this.state.form_data.record.person_id + "/"} target="_blank"><i className='fa fa-eye'></i> مشاهده صفحه مجله بر روی سایت سیولیکا</a>}
        {this.state.form_data.record.role_id == 6 && <a href={"/l/" + this.state.form_data.record.person_id + "/"} target="_blank"><i className='fa fa-eye'></i> مشاهده صفحه کنفرانس بر روی سایت سیولیکا</a>}
        {this.state.form_data.record.role_id == 1 && <a href={"/l/" + this.state.form_data.record.person_id + "/"} target="_blank"><i className='fa fa-eye'></i> مشاهده صفحه مرکز بر روی سایت سیولیکا</a>}
        {(this.state.form_data.record.role_id == 6 || this.state.form_data.record.role_id == 7) && <Link to={"/cpapers/new/"}> | <i className='fa fa-plus'></i> افزودن مقاله</Link>}
        {(this.state.form_data.record.role_id == 6 || this.state.form_data.record.role_id == 7) && <Link to={"/posts/new/"}> | <i className='fa fa-plus'></i> افزودن خبر</Link>}
      </div>
      ,
      <div className="row">
        <h4 style={{"display":"none"}} className="alert alert-info text-center">بعد از هر بار ویرایش این اطلاعات بایستی منتظر تایید محتوا از سمت مدیریت سامانه باشید</h4>

        {!this.isNull(this.state.form_data.tempData) ?[
          this.state.form_data.tempData.status === 1 ?
            <h4 className="alert alert-warning text-center">شما محتوای {this.getCaption()} را در تاریخ {this.g2j(this.state.form_data.tempData.edit_date,6)} ویرایش نموده اید. لطفا تا زمان تایید/رد محتوا منتظر بمانید</h4>
          :null
        ,
          this.state.form_data.tempData.status === 2 ?
            <h4 className="alert alert-success text-center">محتوای ارسالی شما در تاریخ {this.g2j(this.state.form_data.tempData.edit_date,6)} مورد تایید قرار گرفت و سامانه بروزرسانی گردید
            {!this.isBlank(this.state.form_data.tempData.note) ? [
              <p>توضیحات کارشناس سیولیکا: {this.state.form_data.tempData.note}</p>
            ] : null}
            </h4>
          :null
        ,
          this.state.form_data.tempData.status === 3 ?
            <h4 className="alert alert-danger text-center">محتوای ارسالی در تاریخ {this.g2j(this.state.form_data.tempData.edit_date,6)} از جانب مدیریت سامانه مورد تایید قرار نگرفت
            {!this.isBlank(this.state.form_data.tempData.note) ? [
              <p>توضیحات کارشناس سیولیکا: {this.state.form_data.tempData.note}</p>
            ] : null}
            </h4>
          :null
        ]:null}

        {this.state.form_data.record.role_id === 6 ?
          !this.isNull(this.state.form_data.confIndexing) ?
            !this.isBlank(this.state.form_data.confIndexing.PaperRecievType) ?
              <h4 className="alert alert-danger text-center">با توجه به اتمام کنفرانس و دریافت فایل مقالات امکان ویرایش این کنفرانس وجود ندارد</h4>
              :null
            :null
        :null}

        {this.state.form_data.record.role_id === 51 ?
          this.state.form_data.record.step === 106 ?
            <h4 className="alert alert-danger text-center">با توجه به نمایه شدن این شماره امکان ویرایش این شماره از مجله وجود ندارد</h4>
          :null
        :null}

        <div className="col-md-5">

          <div className="box box-success">
            <div className="box-header with-border">
              <h3 className="box-title">اطلاعات {this.getCaption()}</h3>
            </div>
            <div className="form-horizontal">
              <div className="box-body">
                {this.state.form_data.record.role_id === 51 &&
                  <div className="form-group">
                    <label className="col-sm-12 control-label">دوره</label>
                    <div className="col-sm-12">
                      <input type="text" className="form-control" placeholder="دوره" onChange={(e) => { this.state.form_data.record.volume = e.target.value }} defaultValue={this.state.form_data.record.volume} />
                    </div>
                  </div>
                }
                {this.state.form_data.record.role_id === 51 &&
                  <div className="form-group">
                    <label className="col-sm-12 control-label">شماره</label>
                    <div className="col-sm-12">
                      <input type="text" className="form-control" placeholder="شماره" onChange={(e) => { this.state.form_data.record.issue = e.target.value }} defaultValue={this.state.form_data.record.issue} />
                    </div>
                  </div>
                }
                {this.state.form_data.record.role_id === 51 &&
                  <div className="form-group">
                    <label className="col-sm-12 control-label">سال انتشار شمسی</label>
                    <div className="col-sm-12">
                      <input type="text" className="form-control" placeholder="سال انتشار شمسی" onChange={(e) => { this.state.form_data.record.aff_type = e.target.value }} defaultValue={this.state.form_data.record.aff_type} />
                    </div>
                  </div>
                }
                {this.state.form_data.record.role_id === 51 &&
                  <div className="form-group">
                    <label className="col-sm-12 control-label">سال انتشار میلادی</label>
                    <div className="col-sm-12">
                      <input type="text" className="form-control" placeholder="سال انتشار میلادی" onChange={(e) => { this.state.form_data.record.organ_type = e.target.value }} defaultValue={this.state.form_data.record.organ_type} />
                    </div>
                  </div>
                }
                {this.state.form_data.record.role_id !== 51 &&
                  <div className="form-group">
                    <label className="col-sm-12 control-label">نام</label>
                    <div className="col-sm-12">
                      <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.state.form_data.record.name = e.target.value }} defaultValue={this.state.form_data.record.name} />
                    </div>
                  </div>
                }
              {this.state.form_data.record.role_id !== 51 &&
                <div className="form-group">
                  <label className="col-sm-12 control-label">نام لاتین</label>
                  <div className="col-sm-12">
                    <input type="text" className="form-control" placeholder="نام" onChange={(e) => { this.state.form_data.record.name_en = e.target.value }} defaultValue={this.state.form_data.record.name_en} />
                  </div>
                </div>
              }
              {this.state.form_data.record.role_id !== 51 &&
                <div className="form-group">
                  <label className="col-sm-1 control-label">استان</label>
                  <div className="col-sm-5">
                    <Select
                      className="autocomplete"
                      isMulti={false}
                      placeholder="انتخاب استان"
                      noOptionsMessage={() => 'موردی یافت نشد'}
                      loadingMessage={() => 'در حال جستجو'}
                      options={this.loadProvincesOptions()}
                      defaultValue={this.state.form_data.record.Province !== null ? [{ value: this.state.form_data.record.Province.provinceId, label: this.state.form_data.record.Province.persianProvinceName }] : null}
                      onChange={e => {
                        this.state.form_data.record.province_id = e.value;
                        this.cityRef.select.setValue(null);
                        this.bindCityFromProvince(e);
                      }
                      }
                    />
                  </div>
                  <label className="col-sm-1 control-label">شهر</label>
                  <div className="col-sm-5">
                    <Select
                      ref={r => this.cityRef = r}
                      className="autocomplete"
                      isMulti={false}
                      placeholder="انتخاب شهر"
                      noOptionsMessage={() => 'موردی یافت نشد'}
                      loadingMessage={() => 'در حال جستجو'}
                      options={this.loadCityOptions()}
                      defaultValue={this.state.form_data.record.City !== null ? [{ value: this.state.form_data.record.City.cityId, label: this.state.form_data.record.City.persianCityName }] : null}
                      onChange={e => {
                        if (e == null) this.state.form_data.record.city_id = null;
                        else this.state.form_data.record.city_id = e.value
                      }}
                    />
                  </div>
                </div>
                }
                {this.state.form_data.record.role_id !== 51 &&
                  <div className="form-group">
                    <label className="col-sm-12 control-label">وبسایت</label>
                    <div className="col-sm-12">
                      <input type="text" className="form-control" placeholder="وبسایت" onChange={(e) => { this.state.form_data.record.website = e.target.value }} defaultValue={this.state.form_data.record.website} />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          
          {this.state.form_data.record.role_id === 6 &&
            this.getConfrenceForm()
          }
        </div>

        {this.state.form_data.record.role_id !== 51 &&
          <div className="col-md-5">

            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">اطلاعات تماس</h3>
              </div>
              <div className="form-horizontal">
                <div className="box-body">

                {this.state.form_data.record.Contacts.map(hit =>
                      <div className="form-group" key={hit.id}>
                        <label className="col-sm-3 control-label">
                          <select className="form-control" defaultValue={hit.contact_type} onChange={(e) => { this.setContactFormValues('contact_type', e, hit.id) }}>
                            <option value="1">تلفن</option>
                            <option value="2">موبایل</option>
                            <option value="3">فکس</option>
                            <option value="4">ایمیل</option>
                            <option value="5">آدرس</option>
                            <option value="6">آدرس لاتین</option>
                            <option value="7">کدپستی</option>
                            <option value="8">صندوق پستی</option>
                            <option value="9">تلگرام</option>
                            <option value="10">اینستاگرام</option>
                            <option value="11">فیسبوک</option>
                            <option value="12">لینکدین</option>
                            <option value="13">گوگل پلاس</option>
                            <option value="14">ریسرچ گیت</option>
                            <option value="15">تویتر</option>
                          </select>
                        </label>
                        <label className="col-sm-8 control-label">
                          <input type="text" className="form-control" placeholder="" onChange={(e) => { this.setContactFormValues('value', e, hit.id) }} defaultValue={hit.value} />
                        </label>
                        <label className="col-sm-1 control-label" style={{ "paddingTop": "15px" }}>
                          <a className="hand" onClick={e => this.removeContacts(e, hit.id)}><i className="fa fa-trash"></i></a>
                        </label>
                      </div>
                    )}
                <div className="form-group">
                  <label className="col-sm-12 text-center">
                    <a className="hand" onClick={e => this.addContacts(e)}><i className="fa fa-plus"></i> افزودن اطلاعات تماس جدید</a>
                  </label>
                </div>

                </div>
              </div>
            </div>

          </div>
        }
        <div className="col-md-2">
          {this.state.form_data.record.role_id === 6 || this.state.form_data.record.role_id === 7 || this.state.form_data.record.role_id === 51 ?
            <div className="box box-info">
              <div className="box-header with-border">
                <h3 className="box-title">تصویر کاور</h3>
              </div>
              <div className="form-horizontal">
                <div className="box-body">
                  {this.state.form_data.record.person_id > 0 || this.state.form_data.record.temp_id > 0 ?
                    <a href={this.toImageUrl(this.state.form_data.record, "legal_person_cover")} target="_blank">
                      <img className="fitImage" src={this.toImageUrl(this.state.form_data.record, "legal_person_cover")} />
                    </a>
                  : null}
                    {this.state.form_data.record.role_id === 51 && <p>اگر طرح روی جلد شماره را آپلود نکنید، از طرح روی جلد کلی مجله برای این شماره استفاده خواهد شد.</p>}
                    <Uploader
                      withPreview={true}
                      withIcon={true}
                      withLabel={false}
                      buttonText='انتخاب عکس کاور'
                      fileSizeError="حجم فایل انتخابی زیاد است"
                      fileTypeError="فرمت فایل انتخابی نامعتبر است"
                      onChange={this.onDropCover}
                      imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg','.webp']}
                      singleImage={true}
                      maxFileSize={5242880}
                    />
                </div>
              </div>
            </div>
          :null}
          {this.state.form_data.record.role_id !== 6 && this.state.form_data.record.role_id !== 7 && this.state.form_data.record.role_id !== 51 ?
            <div className="box box-danger">
              <div className="box-header with-border">
                <h3 className="box-title">تصویر لوگو</h3>
              </div>
              <div className="form-horizontal">
                <div className="box-body">
                  {this.state.form_data.record.person_id > 0 ?
                    <img className="fitImage" src={this.toImageUrl(this.state.form_data.record, "legal_person")} />
                    : null}
                </div>
              </div>
            </div>
          :null}
        </div>

        {this.state.form_data.record.role_id !== 51 && 
          <div className="col-md-12">
            <div className="box box-warning">
              <div className="form-horizontal">
                <div className="box-body">
                  <div className="form-group">
                    <label className="col-sm-12 control-label">توضیحات</label>
                    <div className="col-sm-12">
                      <Editor
                        content={this.state.form_data.record.desc}
                        config={{
                          language: 'fa_IR',
                          directionality: 'rtl',
                          paste_as_text: true,
                          height: 180,
                          plugins: [
                            'directionality textcolor colorpicker image imagetools importcss table searchreplace print preview advlist media lists link insertdatetime autolink paste'
                          ],
                          toolbar: 'ltr rtl alignleft alignright forecolor backcolor table format image forecolor backcolor searchreplace print preview media numlist bullist link insertdatetime',
                          menubar: "insert file edit view format table",
                        }}
                        onChange={e => {
                          this.state.form_data.record.desc = e.target.getContent()
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="col-sm-12 control-label">توضیحات لاتین</label>
                    <div className="col-sm-12">
                      <Editor
                        content={this.state.form_data.record.desc_en}
                        config={{
                          language: 'fa_IR',
                          directionality: 'ltr',
                          paste_as_text: true,
                          height: 180,
                          plugins: [
                            'directionality textcolor colorpicker image imagetools importcss table searchreplace print preview advlist media lists link insertdatetime autolink paste'
                          ],
                          toolbar: 'ltr rtl alignleft alignright forecolor backcolor table format image forecolor backcolor searchreplace print preview media numlist bullist link insertdatetime',
                          menubar: "insert file edit view format table",
                        }}
                        onChange={e => {
                          this.state.form_data.record.desc_en = e.target.getContent()
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

      </div>
      ,
      this.renderRemoveBox()
    ]
  }
  render() {
      if (this.state.form_data === null || this.state.form_data === undefined)
        return this.showLoading();
      if (this.state.form_data.status === 500 || this.state.form_data.status === 0)
        return this.render500()
      if (this.state.form_data.status === 404)
        return this.render404()
      if (this.state.form_data.status === 2)
        return this.renderNoAccess()
      if (this.state.form_data.status === 4)
        return this.renderNoLogin();
    return (
        [
          this.renderBody()
          ,
            <button type="button" className="btn btn-success" onClick={(e) => { this.saveForm(''); }}>ذخیره</button>
          ,
          !this.isNull(this.state.form_data.record.Province) ?
            this.state.cites.length <= 0 ?
              this.bindCityFromProvince({ value: this.state.form_data.record.Province.provinceId }) : null
            : null
        ]
    );
  }
}
const LegalPersonEXP = withRouter(LegalPerson);
export default LegalPersonEXP;